/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyermotifqueue3Inputs */

const en_checkinflyermotifqueue3 = /** @type {(inputs: Checkinflyermotifqueue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue`)
};

const de_checkinflyermotifqueue3 = /** @type {(inputs: Checkinflyermotifqueue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteschlange`)
};

/**
* | output |
* | --- |
* | "Queue" |
*
* @param {Checkinflyermotifqueue3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyermotifqueue3 = /** @type {((inputs?: Checkinflyermotifqueue3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyermotifqueue3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyermotifqueue3(inputs)
	return de_checkinflyermotifqueue3(inputs)
});
export { checkinflyermotifqueue3 as "checkinFlyerMotifQueue" }